import * as React from 'react';
import { Button, LinkButton, Responsive } from '@cian/ui-kit';
import { IBaseButtonProps } from '@cian/ui-kit/button/types';
import { ContactsModal } from '../../components/ContactsModal';
import { IBuilderInfo } from '../../types/buildersProjects';
import { InteractiveElementsWrapper } from '../../components/InteractiveElementsWrapper';

interface ICallButtonContainerProps extends IBaseButtonProps {
  onCallClick?(): void;
  builder: IBuilderInfo;
}

export const CallButtonContainer: React.FC<ICallButtonContainerProps> = ({ builder, onCallClick, ...props }) => {
  const [modalOpened, setModalOpened] = React.useState(false);

  return (
    <InteractiveElementsWrapper>
      <Responsive tablet>
        <Button {...props} data-name="CallButtonShowContacts" onClick={() => setModalOpened(true)} size="L">
          Показать телефон
        </Button>
      </Responsive>
      <Responsive phone>
        <LinkButton {...props} data-name="CallButtonLink" href={`tel:${builder.phone}`} onClick={onCallClick}>
          Позвонить
        </LinkButton>
      </Responsive>
      <ContactsModal {...builder} open={modalOpened} onClose={() => setModalOpened(false)} onCallClick={onCallClick} />
    </InteractiveElementsWrapper>
  );
};
